import styled from 'styled-components';

import { colors } from '@gbs-monorepo-packages/styles';

export const StyledFileName = styled.div<{ $highlighted?: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  max-width: 400px;
  border-radius: 4px;
  padding: 4px 8px;
  transition: all 0.2s ease;
  font-weight: normal;

  ${({ $highlighted }) =>
    $highlighted === true &&
    `
    background-color: ${colors.lightGray50};
    border: 1px solid ${colors.lightGray200};
    color: ${colors.gray300};
  `}
`;

export const StyledStarContainer = styled.span`
  display: inline-block;
`;
